import React from 'react';

import { ConfluencePreviewPanelsProvider } from '@confluence/preview-panel-api';
import { NotesContextProvider } from '@confluence/notes-util/entry-points/NotesContext';
import { RightSidebarContextProvider } from '@confluence/page-layout-context';
import { InProductHelpProvider } from '@confluence/in-product-help';
import { fg } from '@confluence/feature-gating';

type PageLayoutContextProviderWrapperPropsType = {
	children: React.ReactNode;
};

export const PageLayoutContextProviderWrapper = ({
	children,
}: PageLayoutContextProviderWrapperPropsType) => {
	if (!fg('confluence_preview_panels')) {
		return (
			<RightSidebarContextProvider>
				<NotesContextProvider>
					<InProductHelpProvider>{children}</InProductHelpProvider>
				</NotesContextProvider>
			</RightSidebarContextProvider>
		);
	}

	return (
		<ConfluencePreviewPanelsProvider>
			<RightSidebarContextProvider>
				<NotesContextProvider>
					<InProductHelpProvider>{children}</InProductHelpProvider>
				</NotesContextProvider>
			</RightSidebarContextProvider>
		</ConfluencePreviewPanelsProvider>
	);
};
